<template>
  <div>
    <v-app-bar
      id="home-app-bar"
      app
      color="white"
      elevation="1"
      height="80"
    >
      <a
        href="/"
      >
        <base-img
          :src="require('@/assets/logo-flag.svg')"
          contain
          max-width="110"
          width="100%"
        />
      </a>
      <span class="font-weight-bold mx-3 my-4 hidden-xs-only">X</span>
      <a
        href="https://www.lithos.kr"
        target="_blank"
      >
        <base-img
          :src="require('@/assets/logo-lithos.svg')"
          class="mr-3 hidden-xs-only"
          contain
          max-width="100"
          width="100%"
        />
      </a>

      <v-spacer />

      <div>
        <v-tabs
          class="hidden-sm-and-down"
          optional
        >
          <v-tab
            v-for="(name, i) in items"
            :key="i"
            :to="{ name }"
            :exact="name === 'Home'"
            :ripple="false"
            active-class="text--primary"
            class="font-weight-bold"
            min-width="96"
            text
          >
            {{ name }}
          </v-tab>
          <v-btn
            class="ma-2"
            depressed
            rounded
            color="primary"
            href="https://web.flagfms.com"
            target="_blank"
          >
            시작하기 〉
          </v-btn>
        </v-tabs>
      </div>

      <v-app-bar-nav-icon
        class="hidden-md-and-up"
        @click="drawer = !drawer"
      />
    </v-app-bar>

    <home-drawer
      v-model="drawer"
      :items="items"
    />
  </div>
</template>

<script>
  export default {
    name: 'HomeAppBar',

    components: {
      HomeDrawer: () => import('./Drawer'),
    },

    data: () => ({
      drawer: null,
      items: [
        'Home',
        'About',
        'Contact',
      ],
    }),
  }
</script>

<style lang="sass">
  #home-app-bar
    .v-tabs-slider
      max-width: 24px
      margin: 0 auto

    .v-tab
      &::before
        display: none
</style>
